var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"i-title",style:({ marginBottom: _vm.bottom })},[_c('div',{staticClass:"t-main"},[_vm._v(" "+_vm._s(_vm.title)+" "),_c('img',{staticClass:"t-pic",attrs:{"src":require('@/assets/images/Mall/w1.png'),"alt":""}})])])}
var staticRenderFns = []

export { render, staticRenderFns }